module.exports = __webpack_public_path__ + "resources/img/img_appguard1_m.64c1faaf33a65dedafea39514cae2ba4.png";